import Cloth from 'casino/playfields/Cloth';

const DoubleDownGame = () => <Cloth>Double Down Stud</Cloth>;

export default DoubleDownGame;
